/**
 * Tətbiqin versiya və müəlliflik məlumatı — vahid mənbə.
 *
 * Versiya dəyişəndə public/sw.js içindəki CACHE_NAME də artırılmalıdır,
 * yoxsa PWA quraşdırmış mobil istifadəçilər köhnə keşdə ilişib qalır.
 */
export const APP_VERSION = '1.3';
export const RELEASE_DATE = '2026-11-02';

export const APP_INFO = {
  name:        'EMS — Elektron Məktəb Sistemi',
  shortName:   'EMS',
  org:         'Heydər Əliyev adına Müasir Təhsil Kompleksi',
  author:      'Eldar Cəbrayılov',
  authorRole:  'İT koordinatoru',
  authorEmail: 'eldar.jabrailov@mtk.edu.az',
  copyrightYear: 2026,
};

export default APP_VERSION;
